import PropTypes from 'prop-types';

export { default as fateData } from './fateData';

export const fateCard = PropTypes.shape({
  action: PropTypes.string.isRequired,
  border: PropTypes.string,
  canAfford: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.arrayOf(PropTypes.number).isRequired,
  ]).isRequired,
  type: PropTypes.string.isRequired,
});